import React from 'react';

interface BulletedListIconProps {
  size?: number;
  color?: string;
}

const BulletedListIcon: React.FC<BulletedListIconProps> = ({ 
  size = 20, 
  color = 'currentColor' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="3.5" cy="6" r="0.5" fill={color} />
      <line x1="10" y1="6" x2="25" y2="6" />
      <circle cx="3.5" cy="12" r="0.5" fill={color} />
      <line x1="10" y1="12" x2="25" y2="12" />
      <circle cx="3.5" cy="18" r="0.5" fill={color} />
      <line x1="10" y1="18" x2="25" y2="18" />
    </svg>
  );
};

export default BulletedListIcon; 